// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validate-header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.validate-header-title {
  font-weight: 600 !important;
  line-height: 1 !important;
  color: #333 !important;
}

.validate-header-subtitle {
  color: grey;
  font-size: 14px;
}

.validate-header-new-prod {
  color: grey;
  font-size: 1.2rem;
  font-weight: 700;
}

.validate-header-title-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.validate-header-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid #dbdbdb;
}

.validate-proceed-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
}

.error-img-box {
  background-color: red;
  padding-top: 2%;
  padding-bottom: 2%;
  border-radius: 10px;
}

.text-in-modal-box {
  padding-left: 2%;
  padding-right: 2%;
  padding-bottom: 2%;
}

.ods-modal-close-button {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.add-new-btn-ods {
  /* border-radius: 50% !important; */
  padding: 4px 8px !important;
  border-radius: 4px;
}

.search-add-item-input {
  background-color: #F5F5F5 !important;
  border: 1px solid #f5f5f5 !important;
  border-radius: 4px;
  padding: 4px 8px;
  outline: none !important;
}

.add-new-product-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.add-or-scan-ods {
  min-height: 400px !important;
  width: 100%;
  text-align: center;
}

.scan-to-product-box {
  height: 360px !important;
  overflow: scroll;
}

.no-display-no-result {
  display: none !important;
}

/* ── Dark theme ── */
.dark .validate-header-box {
  border-bottom: 1px solid #334155;
  padding-bottom: 0.5rem;
}

.dark .validate-proceed-btn {
  border-top: 1px solid #334155;
  padding-top: 0.5rem;
}

.dark .validate-header-title {
  color: #f1f5f9 !important;
}

.dark .validate-header-subtitle {
  color: #64748b;
}

.dark .validate-header-new-prod {
  color: #94a3b8;
}

.dark .validate-header-icon {
  border-color: #334155;
}

.dark .search-add-item-input {
  background-color: #1e293b !important;
  border-color: #334155 !important;
  color: #f1f5f9;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/ValidationModal/ValidationModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB","sourcesContent":[".validate-header-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.validate-header-title {\n  font-weight: 600 !important;\n  line-height: 1 !important;\n  color: #333 !important;\n}\n\n.validate-header-subtitle {\n  color: grey;\n  font-size: 14px;\n}\n\n.validate-header-new-prod {\n  color: grey;\n  font-size: 1.2rem;\n  font-weight: 700;\n}\n\n.validate-header-title-box {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.validate-header-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  border: 1px solid #dbdbdb;\n}\n\n.validate-proceed-btn {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.error-img-box {\n  background-color: red;\n  padding-top: 2%;\n  padding-bottom: 2%;\n  border-radius: 10px;\n}\n\n.text-in-modal-box {\n  padding-left: 2%;\n  padding-right: 2%;\n  padding-bottom: 2%;\n}\n\n.ods-modal-close-button {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.add-new-btn-ods {\n  /* border-radius: 50% !important; */\n  padding: 4px 8px !important;\n  border-radius: 4px;\n}\n\n.search-add-item-input {\n  background-color: #F5F5F5 !important;\n  border: 1px solid #f5f5f5 !important;\n  border-radius: 4px;\n  padding: 4px 8px;\n  outline: none !important;\n}\n\n.add-new-product-toggle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.add-or-scan-ods {\n  min-height: 400px !important;\n  width: 100%;\n  text-align: center;\n}\n\n.scan-to-product-box {\n  height: 360px !important;\n  overflow: scroll;\n}\n\n.no-display-no-result {\n  display: none !important;\n}\n\n/* ── Dark theme ── */\n.dark .validate-header-box {\n  border-bottom: 1px solid #334155;\n  padding-bottom: 0.5rem;\n}\n\n.dark .validate-proceed-btn {\n  border-top: 1px solid #334155;\n  padding-top: 0.5rem;\n}\n\n.dark .validate-header-title {\n  color: #f1f5f9 !important;\n}\n\n.dark .validate-header-subtitle {\n  color: #64748b;\n}\n\n.dark .validate-header-new-prod {\n  color: #94a3b8;\n}\n\n.dark .validate-header-icon {\n  border-color: #334155;\n}\n\n.dark .search-add-item-input {\n  background-color: #1e293b !important;\n  border-color: #334155 !important;\n  color: #f1f5f9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
